import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-audit-logs",
  templateUrl: "./audit-logs.component.html",
  styleUrls: ["./audit-logs.component.css"],
})
export class AuditLogsComponent implements OnInit {
  timezoneInfo: boolean = false;
  selectedTimeZone: string = "";
  localTimeZone: string = "";

  constructor() {}

  ngOnInit() {
    this.selectedTimeZone = localStorage.getItem("selectedTimeZone");
    this.localTimeZone = localStorage.getItem("localTimeZone");
    this.checkTimezone();
  }

  checkTimezone() {
    var dt = new Date();
    var offset = dt.getTimezoneOffset();
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    if (Math.abs(offset) !== Math.abs(timezone)) {      
      this.timezoneInfo = true;
    } else {      
      this.timezoneInfo = false;
    }
  }

}
